import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

export interface ModeType {
  type: 'music' | 'mixtape';
  setType : (type: 'music' | 'mixtape') => void;
}
export const useModeType = create(
  persist<ModeType>(
    (set) => ({
      type: 'mixtape',
      setType: (type: 'music' | 'mixtape') =>
        set(() => ({
          type,
        })),
    }),
    {
      name: 'mode-type',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
)